import * as Sentry from '@sentry/browser';
import { node } from 'prop-types';
import React from 'react';
import { Alert, Button } from 'reactstrap';

import storedUserInfo from '../utils/session-data/user-info';

class GlobalErrorBoundary extends React.Component {
  constructor(props) {
    super(props);

    this.state = { error: null, errorId: '' };

    this.showReportDialog = this.showReportDialog.bind(this);
  }

  componentDidCatch(error, errorInfo) {
    this.setState({ error });

    Sentry.withScope(scope => {
      const user = storedUserInfo.get();

      if (user) {
        scope.setUser({
          id: user.id,
          username: [user.firstName, user.lastName].join(' '),
          email: user.email,
        });
      }

      Object.keys(errorInfo).forEach(key => {
        scope.setExtra(key, errorInfo[key]);
      });

      const errorId = Sentry.captureException(error);

      this.setState({ errorId });
    });
  }

  showReportDialog() {
    const { errorId } = this.state;
    Sentry.showReportDialog({ errorId });
  }

  render() {
    if (this.state.error) {
      // TODO: show error?
      return (
        <Alert color="danger" className="m-5">
          Something went terribly wrong! A bug report has been stored. But if
          you can provide some additional information on how you got here, that
          will help us fixing this problem for others.
          <Button type="button" onClick={this.showReportDialog}>
            Report
          </Button>
        </Alert>
      );
    }

    return this.props.children;
  }
}

GlobalErrorBoundary.propTypes = {
  children: node.isRequired,
};

export default GlobalErrorBoundary;
